import {Observable} from 'rxjs';
import type {ActionsObservable} from 'redux-observable';
import {switchMap, map, catchError} from 'rxjs/operators';

import type {ContactsApiResponse} from '../types';
import {fetchContactById} from './contacts-api';
import {ActionTypes, resolveFetchById, failFetchById} from './contacts-actions';
import type {ContactsAction, ActionFetchByIdRequest} from './contacts-actions';

type FetchContactById = (contactId: string) => Promise<ContactsApiResponse>;

// Need this to be a factory so we can inject a different api method for the chrome extension
export const makeFetchContactByIdEpic =
    (fetch: FetchContactById) => (action$: ActionsObservable<ContactsAction>) =>
        action$.ofType(ActionTypes.CONTACTS_FETCH_BY_ID_REQUEST).pipe(
            // @ts-ignore
            switchMap((action: ActionFetchByIdRequest) => {
                return Observable.from(fetch(action.payload)).pipe(
                    map((response: ContactsApiResponse) => resolveFetchById(response)),
                    catchError((error) => Observable.of(failFetchById(error)))
                );
            })
        );

export const fetchContactByIdEpic = makeFetchContactByIdEpic(fetchContactById);
